import React from "react";
import styles from "./styles.module.scss";
import spareImg from "../../../../shared/images/spare.svg";
import { useStoreon } from "storeon/react";

const LastFrameCurrent = (props) => {
  const { players, title } = props;
  const { tableSettings, loggedInUserProfile } = useStoreon(
    "tableSettings",
    "loggedInUserProfile"
  );
  const { accountType } = loggedInUserProfile;
  const loggedInUser = localStorage.getItem("loggedInUser");
  const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);
  const squares = new Array(3).fill("");

  const findLastUp = (array) => {
    const temp = !(array.length % 2) ? array : [...array, ""];
    const last = temp.length > 6 ? temp.slice(temp.length - 6) : temp;

    return last.filter((val, index) => !(index % 2));
  };

  const findLastDown = (array) => {
    const temp = !(array.length % 2) ? array : [...array, ""];
    const last = temp.length > 6 ? temp.slice(temp.length - 6) : temp;
    return last.filter((val, index) => !!(index % 2));
  };

  const isSplit = (pin) => {
    return Math.floor(pin / 1024) === 1;
  };

  //   const isActive = (laneThrow) => {
  //     return laneThrow.activePlayer || laneThrow.active_player;
  //   };

  const calculateCurrentSquare = (laneThrow) => {
    return (
      (laneThrow.throws &&
        Math.round(
          (((laneThrow.throws && laneThrow.throws.length) || 0) + 1) / 2
        )) ||
      1
    );
  };

  const someStyle = {
    "--evenBackground": tableSettings.evenRows.background,
    "--evenColor": tableSettings.evenRows.color,
    "--evenFontSize": tableSettings.evenRows.fontSize,
    "--evenFontWeight": tableSettings.evenRows.fontWeight,
    "--oddBackground": tableSettings.oddRows.background,
    "--oddColor": tableSettings.oddRows.color,
    "--oddFontSize": tableSettings.oddRows.fontSize,
    "--oddFontWeight": tableSettings.oddRows.fontWeight,
    "--scoreBackground": tableSettings.maxScore.background,
    "--scoreColor": tableSettings.maxScore.color,
    "--scoreFontSize": tableSettings.maxScore.fontSize,
    "--scoreFontWeight": tableSettings.maxScore.fontWeight,
    "--frameContainerBackground": tableSettings.frameContainer.background,
    "--frameContainerColor": tableSettings.frameContainer.color,
    "--frameContainerFontSize": tableSettings.frameContainer.fontSize,
    "--frameContainerFontWeight": tableSettings.frameContainer.fontWeight,
    "--sectionContainerBackground": tableSettings.sectionContainerBackground,
    "--fontFamily":
      loggedInUserObj.accountType === "Freemium"
        ? "Roboto Mono"
        : "'Saira', sans-serif",
    "--turnFontWeight": "600",
  };

  return (
    <div className={styles.containerTable} style={someStyle}>
      <div className={styles.title}>{title}</div>
      {players && players.length ? (
        <div className={styles.playersCard}>
          <div className={styles.bodyTable}>
            <div className={styles.turns} style={someStyle}>
              <span className={styles.turn}>Frame</span>
              <span className={`${styles.turn} ${styles.lastFrames}`}>
                Last 3 Frames
              </span>
              <span className={`${styles.turn} ${styles.maxScore}`}>
                Max Score
              </span>
            </div>
            {players.map((laneThrow, ind) => {
              const lastThrowUp = findLastUp(laneThrow.throws);
              const lastThrowDown = findLastDown(laneThrow.throws);
              const lastPinsUp = findLastUp(laneThrow.pins);
              const lastPinsDown = findLastDown(laneThrow.pins);

              return (
                <div className={styles.players} key={ind}>
                  <div className={styles.squares}>
                    <span
                      className={styles.playerName}
                      style={{ minWidth: "130px", maxWidth: "140px" }}
                    >
                      {laneThrow.displayName || laneThrow.playerName}
                    </span>
                    <span className={`${styles.square} ${styles.frame}`}>
                      {Math.round(((laneThrow.throws.length || 0) + 1) / 2) ||
                        1}
                    </span>
                    {squares.map((e, index) => (
                      <span
                        className={`${styles.square} ${styles.active} ${
                          laneThrow.throws &&
                          laneThrow.throws.length > index * 2 &&
                          styles.past
                        } ${
                          index + 1 === calculateCurrentSquare(laneThrow) &&
                          styles.current
                        }`}
                        key={index}
                        /*style={someStyle}*/
                      >
                        {(lastThrowUp &&
                          lastThrowUp.length &&
                          lastThrowUp[index] !== "X" &&
                          index < 9 && (
                            <span className={styles.numbers}>
                              <span
                                className={`${styles.number} ${
                                  isSplit(lastPinsUp[index]) && styles.split
                                }`}
                              >
                                {lastThrowUp &&
                                  lastThrowUp.length &&
                                  lastThrowUp[index]}
                              </span>
                              {lastThrowDown &&
                                lastThrowDown.length &&
                                lastThrowDown[index] !== "/" && (
                                  <span
                                    className={`${styles.number} ${
                                      isSplit(lastPinsDown[index]) &&
                                      styles.split
                                    }`}
                                  >
                                    {lastThrowDown[index]}
                                  </span>
                                )}
                              {lastThrowDown &&
                                lastThrowDown.length &&
                                lastThrowDown[index] === "/" && (
                                  <span className={styles.number}>
                                    <img src={spareImg} alt="" />
                                  </span>
                                )}
                            </span>
                          )) ||
                          ""}
                        {(lastThrowUp &&
                          lastThrowUp.length &&
                          lastThrowUp[index] === "X" && (
                            <span className={styles.strike}>X</span>
                          )) ||
                          ""}
                      </span>
                    ))}
                    <span
                      className={`${styles.square} ${styles.maxScore}`}
                      style={someStyle}
                    >
                      {laneThrow.maxScore}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div>There are no players</div>
      )}
    </div>
  );
};

export default LastFrameCurrent;
